'use strict'

const includes_ = require('lodash/includes')
const { types: inputComponentTypes } = require('./inputComponents')

module.exports = component => includes_(inputComponentTypes, component.type)



// WEBPACK FOOTER //
// ../node_modules/dbsm-common/src/isInputComponent.js